/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";

export default function UseDebounce(value, delay) {
  const [debounceItem, setDebounceItem] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounceItem(value);
    }, delay);
    return () => {
      clearTimeout(timer);
    };
  }, [value,delay]);

  return debounceItem;
}
